export const FORM_FILTER_COMMERCIAL = 'FORM_FILTER_COMMERCIAL';
export const REFRESH_TABLE_COMMERCIAL = 'REFRESH_TABLE_COMMERCIAL';
